'use strict';

var React = require('react'),
    Recaptcha = require('react-recaptcha'),
    FormLink = require('../utils/FormLink'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    ApiKeys = require('../constants/ApiKeys'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

require('../molecules/FormInputRow.less');

var RecaptchaFormRow = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    onVerify: React.PropTypes.func.isRequired,
  },

  className: 'FormInputRow',

  handleVerify: function (response) {
    this.props.formLink.requestChange(response);
  },

  render: function () {
    var formLink = this.props.formLink;

    return (
      <div className={this.getClassName()}>
        <Recaptcha
          sitekey={ApiKeys.RE_CAPTCHA_SITEKEY}
          render="explicit"
          onloadCallback={function(){}}
          verifyCallback={this.handleVerify}
        />
        {this.renderMessage()}
      </div>
    );
  },

  renderMessage: function () {
    var formLink = this.props.formLink,
        fieldMessage = formLink.fieldMessage;

    if (!fieldMessage) {
      return;
    }

    if (!fieldMessage.isError) {
      return (
        <div className='FormInputRow-help'>
          {fieldMessage.message}
        </div>
      );
    }

    // hasFormError will get reset on next tick,
    // so we use it to trigger the animation

    var animateShake = !formLink.hasFormError;
    return (
      <div className='FormInputRow-error'
           data-animate={animateShake}>
        {fieldMessage.message}
      </div>
    );
  }
});

module.exports = RecaptchaFormRow;



/** WEBPACK FOOTER **
 ** ./organisms/RecaptchaFormRow.jsx
 **/